var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateTemplateModifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45923 20.4102H10.7051",
    stroke: "#368FEF",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10,
    strokeDasharray: "1.21 1.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5902 24.6557H11.918V7.06557C11.918 6.05869 11.1052 5.2459 10.0984 5.2459C9.09148 5.2459 8.27869 6.05869 8.27869 7.06557V18.5902C8.27869 19.597 7.4659 20.4098 6.45902 20.4098C5.45213 20.4098 4.63934 19.597 4.63934 18.5902V2.81967C4.63934 1.81279 3.82656 1 2.81967 1C1.81279 1 1 1.81279 1 2.81967V4.03279H3.42623",
    stroke: "#368FEF",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10,
    strokeDasharray: "1.21 1.21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0984 5.24609H25.2623C26.2692 5.24609 27.082 6.05888 27.082 7.06577V24.6559H24.6558",
    stroke: "#368FEF",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10,
    strokeDasharray: "1.21 1.21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42627 1H17.9836C18.9905 1 19.8033 1.81279 19.8033 2.81967V4.03279",
    stroke: "#368FEF",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10,
    strokeDasharray: "1.21 1.21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9509 12.5249H24.0493",
    stroke: "#505050",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9509 14.9512H20.4099",
    stroke: "#505050",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9509 10.0986H24.0493",
    stroke: "#505050",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6657 25.0786H20.5567L20.2247 17.3936H22.9977L22.6657 25.0786ZM20.1477 27.4736C20.1477 27.0916 20.2857 26.7786 20.5607 26.5346C20.8357 26.2896 21.1797 26.1676 21.5917 26.1676C22.0037 26.1676 22.3477 26.2896 22.6237 26.5346C22.8987 26.7786 23.0367 27.0916 23.0367 27.4736C23.0367 27.8536 22.8987 28.1666 22.6237 28.4116C22.3477 28.6556 22.0037 28.7776 21.5917 28.7776C21.1797 28.7776 20.8357 28.6556 20.5607 28.4116C20.2857 28.1666 20.1477 27.8536 20.1477 27.4736Z",
    fill: "#368FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateTemplateModifier);
export default __webpack_public_path__ + "static/media/certificate_template_modifier.4f268062fc8b6d746164a483ce0c712c.svg";
export { ForwardRef as ReactComponent };